var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var CHALLENGE_CLOSED = 'challenge-closed';
var SCRIPT_UNAVAILABLE = 'script-unavailable';
var SCRIPT_LOAD_TIMEOUT_MS = 10000;
var widgetIds = new WeakMap();
var loadHcaptcha = function () {
    return new Promise(function (resolve, reject) {
        var script = document.querySelector('#hcaptchaScript');
        var hcaptcha = window.hcaptcha;
        if (!script) {
            resolve(null);
            return;
        }
        if (hcaptcha) {
            resolve(hcaptcha);
            return;
        }
        var timeout = setTimeout(function () { return reject(SCRIPT_UNAVAILABLE); }, SCRIPT_LOAD_TIMEOUT_MS);
        script.addEventListener('load', function () {
            clearTimeout(timeout);
            resolve(window.hcaptcha);
        });
        script.addEventListener('error', function () {
            clearTimeout(timeout);
            reject(SCRIPT_UNAVAILABLE);
        });
    });
};
export var getInvisibleCaptchaResponse = function (container) { return __awaiter(void 0, void 0, void 0, function () {
    var hcaptcha, sitekey, widgetId, response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, loadHcaptcha()];
            case 1:
                hcaptcha = _b.sent();
                if (!hcaptcha) {
                    return [2, null];
                }
                if (!widgetIds.has(container)) {
                    sitekey = (_a = document.querySelector('#hcaptchaScript')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-sitekey');
                    widgetIds.set(container, hcaptcha.render(container, { sitekey: sitekey, size: 'invisible' }));
                }
                widgetId = widgetIds.get(container);
                _b.label = 2;
            case 2:
                _b.trys.push([2, , 4, 5]);
                return [4, hcaptcha.execute(widgetId, { async: true })];
            case 3:
                response = (_b.sent()).response;
                return [2, response];
            case 4:
                hcaptcha.reset(widgetId);
                return [7];
            case 5: return [2];
        }
    });
}); };
export var isCaptchaClosedError = function (error) {
    return error === CHALLENGE_CLOSED;
};
